import Cookie from 'js-cookie';

export default function makeCustomerCareInfo(info: Record<string, any>) {
  return {
    ...info,
    vid: Cookie.get('vid'),
    cookie: document.cookie,
  };
}
